import {GET_CLIENT_DATA, GET_DP_DATA, GET_BU_DATA, RESET_CLIENT_DATA, RESET_DP_DATA, RESET_BU_DATA, CLIENT_DATA_SEARCH, RESET_CLIENT_DATA_SEARCH} from '../../constants/reducerTypes';

const initialState = {};
const ClientDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CLIENT_DATA:
      return {
        ...state,
        clientData: action.payload,
      };
    case GET_DP_DATA:
      return {
        ...state,
        dpData: action.payload,
      };
    case GET_BU_DATA:
      return {
        ...state,
        buData: action.payload,
      };
    case CLIENT_DATA_SEARCH:
      return {
        ...state,
        clientDataSearch: action.payload,
      };
    case RESET_CLIENT_DATA:
      return {
        ...initialState
      };
    case RESET_DP_DATA:
      return {
        ...initialState
      };
    case RESET_BU_DATA:
      return {
        ...initialState
      };
    case RESET_CLIENT_DATA_SEARCH:
      return {
        ...initialState
      };
    default:
      return state;
  }
};

export default ClientDataReducer;
